
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiExclamationMark as ObiExclamationMarkElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-exclamation-mark.js';
 
 
 

 
 export const ObiExclamationMark = createComponent({
   react: React,
   tagName: 'obi-exclamation-mark',
   elementClass: ObiExclamationMarkElement,
   events: {
     
   }
  });
 
 